/*
    nsInclude directive - This will include html from the given url.
    gotchas - This directive shares scope with the controller if you want isolate scope use ng-include.
    Just make sure your ns-includes don't manipulate the same model object on the scope.
    ex: <div ns-include="someurl"></div>
 */
import $ from '@nuskin/nuskinjquery';
import {utilModule} from '../module.js';

utilModule.directive('nsInclude', ['$http', '$compile', '$timeout','nsUtil', function($http,$compile,$timeout,nsUtil) {
    return {
        restrict: 'A',
        link: function(scope, ele, attr){
            let modelObject = null;

            /*
                Function to parse ng-model attribute to get the model object and create a default object
                that contains the default values for the form
             */
            function setModelObject(prop) {
                let parts = prop.split('.');
                modelObject = scope;
                for (let i = 0; i < parts.length; i++) {
                    modelObject = modelObject[parts[i]];
                }
            }

            function sanitizeHTML($staging) {
                if(typeof attr.removestyle !== 'undefined') {
                    $staging.find('style').remove();
                }
                if(typeof attr.removejs !== 'undefined') {
                    $staging.find('script').remove();
                }
                if(typeof attr.removestyle !== 'undefined') {
                    $staging.find('meta').remove();
                    $staging.find('title').remove();
                }
            }

            if (!ele.hasClass("compiling")) {
                /*
                    Watch the ns-include attribute so when the url changes we pull in the new html
                 */
                scope.$watch(attr.nsInclude, function() {
                    let url = scope.$eval(attr.nsInclude),
                        ext;
                    if (url) {
                        let match = url.match(/(\.\w+)$/g);

                        if (match && match.length > 0){
                            ext = match[0];
                        }
                    }

                    if (ext) {
                        ext = ext.toLowerCase();
                    }
                    //-----------------------
                    //  PDF
                    //-----------------------
                    if (url != null && url.length > 0 && ext && ext == '.pdf') {
                        let html = '<object data="' + url + '" type="application/pdf" width="100%" height="100%">'
                            +'<p>No PDF viewer found. <a href="' + url + '">Click here to Download</a></p>'
                            + '</object>';
                        $(ele).html(html);

                    }
                    //-----------------------
                    //  ALL OTHERS
                    //-----------------------
                    else if (url != null && url.length > 0) {
                        // Use the ajax call instead of $http because the ajax call doesn't send a OPTIONS call first. The OPTIONS call was failing with a 401.
                        $.ajax({
                            url: url
                        }).done(function (response) {
                            let bodyIndex = response.indexOf('<body');  //Body tag may have attribute
                            if (bodyIndex > 0) {
                                response = response.substr(bodyIndex);
                                response = response.substr(response.indexOf('>') + 1); //End of body tag
                                if (response.indexOf("</body>") > 0) {
                                    response = response.substring(0, response.indexOf('</body>'));
                                }
                            }
                            ele.empty();
                            let $staging = $('<div></div>');
                            $staging.html(response);
                            sanitizeHTML($staging);
                            $staging.appendTo(ele);
                            ele.addClass("compiling");
                            // Add to the DOM and compile the Angular
                            $compile(ele.parent())(scope);
                            // If we are including a CQ form.  Grab the default with new values from the form.  Lots of parsing.
                            if (ele.parent().is('form')) {
                                // The first child of a ajax loaded form is a parsys.  So we need to get the parsys then the children of the parsys.
                                let elmnts = ele.parent()[0].elements;

                                for (let i = 0; i < elmnts.length; i++) {
                                    let ngModelString = elmnts[i].getAttribute("ng-model");
                                    if (ngModelString !== null) {
                                        setModelObject(ngModelString.substr(0, ngModelString.lastIndexOf('.')));
                                        break;
                                    }
                                }

                                nsUtil.setModelDefaultValues(ele.parent()[0], modelObject);
                            }
                            scope.$emit('nsIncludeContentLoaded');
                            // Force a reflow to ensure the contents are visible
                            // Hack to fix iOS rendering issues with DIVs/iFrames being cut off
                            //                            $timeout(function () {
                            //                                var $ele = $(ele);
                            //                                if ($ele.parent()) {
                            //                                    $ele.parent().hide().show(0);
                            //                                }
                            //                            }, 200);
                        });
                    }
                });
            } else {
                // Note that when we do $compile(ele.parent())(scope), this will initiate another call of the link function
                // which will call the $watch function.
                // Therefore, we have to prevent this double $watch
                ele.removeClass("compiling");
            }
        }
    }
}]);
